<dm-sidebar variant="floating" collapsible="icon">
  <dm-sidebar-header>
    <div class="lp-sidebar-navigation__brand">
      <lp-logo variant="full" appearance="on-brand" />
      <span class="lp-sidebar-navigation__brand-badge">ADMIN</span>
    </div>
    <div class="lp-sidebar-navigation__toolbar">
      <dm-sidebar-input class="lp-sidebar-navigation__search-wrap">
        <button type="button" class="lp-sidebar-navigation__search" (click)="openCommandPalette()">
          <dm-icon name="search-lg" />
          <span class="dm-sidebar-collapse-hide" i18n="@@sidebar.search">Suche</span>
        </button>
      </dm-sidebar-input>
      <dm-tooltip
        label="Sidebar einklappen"
        i18n-label="@@sidebar.einklappen"
        placement="bottom"
        class="lp-sidebar-navigation__trigger-wrap"
      >
        <dm-sidebar-trigger>
          <dm-icon name="layout-left" />
        </dm-sidebar-trigger>
      </dm-tooltip>
    </div>
  </dm-sidebar-header>

  <dm-sidebar-content>
    <dm-sidebar-group>
      <dm-sidebar-menu>
        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="bar-chart-square-02"
            label="Dashboard"
            i18n-label="@@sidebar.dashboard"
            tooltip="Dashboard"
            i18n-tooltip="@@sidebar.dashboard"
            [routerLink]="path('DASHBOARD')"
            [href]="path('DASHBOARD')"
            routerLinkActive
            #dashboardActive="routerLinkActive"
            [isActive]="dashboardActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item>
          <dm-sidebar-collapsible label="Erlasse" i18n-label="@@sidebar.erlasse" icon="scales-01">
            <dm-sidebar-menu-sub-item>
              <dm-sidebar-menu-sub-button
                label="Erlasse"
                i18n-label="@@sidebar.erlasse"
                [routerLink]="path('ADMIN_REGULATIONS')"
                [href]="path('ADMIN_REGULATIONS')"
                routerLinkActive
                #regulationsActive="routerLinkActive"
                [isActive]="regulationsActive.isActive"
              />
            </dm-sidebar-menu-sub-item>
            <dm-sidebar-menu-sub-item>
              <dm-sidebar-menu-sub-button
                label="Internationale Erlasse"
                i18n-label="@@sidebar.internationaleErlasse"
                [routerLink]="path('ADMIN_REGULATIONS_INTERNATIONAL')"
                [href]="path('ADMIN_REGULATIONS_INTERNATIONAL')"
                routerLinkActive
                #internationalRegulationsActive="routerLinkActive"
                [isActive]="internationalRegulationsActive.isActive"
              />
            </dm-sidebar-menu-sub-item>
            <dm-sidebar-menu-sub-item>
              <dm-sidebar-menu-sub-button
                label="SUVA-Checklisten"
                i18n-label="@@sidebar.suvaChecklisten"
                [routerLink]="path('ADMIN_REGULATIONS_SUVA_CHECKLISTS')"
                [href]="path('ADMIN_REGULATIONS_SUVA_CHECKLISTS')"
                routerLinkActive
                #suvaChecklistsActive="routerLinkActive"
                [isActive]="suvaChecklistsActive.isActive"
              />
            </dm-sidebar-menu-sub-item>
          </dm-sidebar-collapsible>
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="message-alert-circle"
            label="Kommentare"
            i18n-label="@@sidebar.kommentare"
            tooltip="Kommentare"
            i18n-tooltip="@@sidebar.kommentare"
            [routerLink]="path('ADMIN_COMMENTS')"
            [href]="path('ADMIN_COMMENTS')"
            routerLinkActive
            #commentsActive="routerLinkActive"
            [isActive]="commentsActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="scales-02"
            label="Vernehmlassungen"
            i18n-label="@@sidebar.vernehmlassungen"
            tooltip="Vernehmlassungen"
            i18n-tooltip="@@sidebar.vernehmlassungen"
            [routerLink]="path('ADMIN_CONSULTATIONS')"
            [href]="path('ADMIN_CONSULTATIONS')"
            routerLinkActive
            #consultationsActive="routerLinkActive"
            [isActive]="consultationsActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="package"
            label="Themenbereiche"
            i18n-label="@@sidebar.objekte"
            tooltip="Themenbereiche"
            i18n-tooltip="@@sidebar.objekte"
            [routerLink]="path('ADMIN_OBJECTS')"
            [href]="path('ADMIN_OBJECTS')"
            routerLinkActive
            #objectsActive="routerLinkActive"
            [isActive]="objectsActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="briefcase-01"
            label="Kunden"
            i18n-label="@@sidebar.kunden"
            tooltip="Kunden"
            i18n-tooltip="@@sidebar.kunden"
            [routerLink]="path('ADMIN_CUSTOMERS')"
            [href]="path('ADMIN_CUSTOMERS')"
            routerLinkActive
            #customersActive="routerLinkActive"
            [isActive]="customersActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="pie-chart-03"
            label="Auswertungen"
            i18n-label="@@sidebar.auswertungen"
            tooltip="Auswertungen"
            i18n-tooltip="@@sidebar.auswertungen"
            [routerLink]="path('ADMIN_REPORTS')"
            [href]="path('ADMIN_REPORTS')"
            routerLinkActive
            #reportsActive="routerLinkActive"
            [isActive]="reportsActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="database-01"
            label="Stammdaten"
            i18n-label="@@sidebar.stammdaten"
            tooltip="Stammdaten"
            i18n-tooltip="@@sidebar.stammdaten"
            [routerLink]="path('ADMIN_MASTER_DATA')"
            [href]="path('ADMIN_MASTER_DATA')"
            routerLinkActive
            #masterDataActive="routerLinkActive"
            [isActive]="masterDataActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="settings-02"
            label="Administration"
            i18n-label="@@sidebar.administration"
            tooltip="Administration"
            i18n-tooltip="@@sidebar.administration"
            [routerLink]="path('ADMIN_ADMINISTRATION')"
            [href]="path('ADMIN_ADMINISTRATION')"
            routerLinkActive
            #administrationActive="routerLinkActive"
            [isActive]="administrationActive.isActive"
          />
        </dm-sidebar-menu-item>
      </dm-sidebar-menu>
    </dm-sidebar-group>
  </dm-sidebar-content>

  <dm-sidebar-footer>
    <lp-account-menu appearance="on-brand" [collapsed]="collapsed()" (logout)="logout()" />
  </dm-sidebar-footer>
</dm-sidebar>
